import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, setLanguage } from '@/lib/i18n';

export function useLocale() {
  const { i18n } = useTranslation();
  const code = i18n.language || 'en';

  const change = useCallback((next) => {
    setLanguage(next);
  }, []);

  return useMemo(() => ({
    code,
    languages: SUPPORTED_LANGUAGES,
    change,
  }), [code, change]);
}

export function useLocaleDate() {
  const { i18n } = useTranslation();
  return useCallback((value, opts = {}) => {
    if (!value) return '';
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(i18n.language || 'en', {
        dateStyle: opts.dateStyle || 'medium',
        timeStyle: opts.timeStyle,
        timeZone: opts.timeZone,
      }).format(d);
    } catch {
      return d.toLocaleString();
    }
  }, [i18n.language]);
}

export function useLocaleNumber() {
  const { i18n } = useTranslation();
  return useCallback((value, opts = {}) => {
    if (value == null) return '';
    try {
      return new Intl.NumberFormat(i18n.language || 'en', opts).format(value);
    } catch {
      return String(value);
    }
  }, [i18n.language]);
}
